import clsx from "clsx";
import type { ComponentProps } from "react";

import { Banner } from "@widgets/banner";
import { PageHero } from "@widgets/page-hero";

import { PointInnerContent } from "@features/point-inner-content";

import type { EcotrapType } from "../model";

import s from "./EcotrapPage.module.scss";

export type EcotrapPageProps = ComponentProps<"div"> & {
  ecotrap: EcotrapType;
};

export const EcotrapPage = (props: EcotrapPageProps) => {
  const { ecotrap } = props;

  return (
    <main className={clsx(s.root)}>
      {ecotrap.title && (
        <PageHero
          variant="primary"
          textColor="brown"
          breadcrumbs={["ecotrap"]}
          title={{
            id: 1,
            text: ecotrap?.ecotrap_type?.name
              ? `${ecotrap.title}, ${ecotrap.ecotrap_type.name}`
              : ecotrap.title,
            titleIconSettings: [],
          }}
        />
      )}
      {ecotrap.content.length > 0 && <PointInnerContent data={ecotrap} />}
      {ecotrap.banner && <Banner {...ecotrap.banner} />}
    </main>
  );
};

EcotrapPage.displayName = "EcotrapPage";
